module.exports = __webpack_public_path__ + "img/Sun.53f709c5.svg";